import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader } from "@/components/Loader";

const ADMIN_ROLES = ["platform_admin", "community_admin"];

export const AdminRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <Loader label="Verifying admin access…" />;
  if (!user || !ADMIN_ROLES.includes(user.role)) return <Navigate to="/admin/login" replace />;
  return children;
};
